var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('user-manager',{attrs:{"canEdit":false,"context":'resident',"showAssignedResidents":true,"functionalRoles":_vm.functionalRoles,"toolbarColor":_vm.appColor_ResidentLight,"toolbarColorDark":_vm.appColor_Resident}})}
var staticRenderFns = []

export { render, staticRenderFns }